module.exports = __webpack_public_path__ + "img/parallax.5db7c675.svg";